"use strict";
/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-04-19 09:23:34.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_AGENT_SETTINGS = void 0;
// default seat config: agent opt-out (useAgent:false); when enabled it runs in the browser and
// auto-submits after 5s. Tuning values mirror the agent cores' constants (kAgentCore / kMctsAgent).
exports.DEFAULT_AGENT_SETTINGS = {
    useAgent: false,
    autoSubmit: true,
    autoSubmitDelay: 5,
    computeOnClient: true,
    agentType: 'heuristic',
    heuristicTuning: { cloneWork: 12000, cloneBudgetMin: 60, cloneBudgetMax: 500, maxBranch: 8 },
    mctsTuning: { iterWork: 350, iterationsMin: 6, iterationsMax: 30, rolloutDepth: 12 }
};
//# sourceMappingURL=core.js.map